export default __webpack_public_path__ + "static/media/bg-sports-featured-match.9dfdb817.png";